const movieBuzzData = {
  hotMovies: [
    {
      id: 1,
      title: 'Avatar: The Way of Water',
      year: 2022,
      poster: 'https://image.tmdb.org/t/p/w300/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg',
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      rating: 4.5,
      commentCount: 1247,
      trending: true,
      latestComment: {
        text: 'CGI tuyệt vời nhất từng thấy! James Cameron thật là thiên tài',
        user: 'MinhNguyen',
        timeAgo: '2 phút trước',
      },
    },
    {
      id: 2,
      title: 'Top Gun: Maverick',
      year: 2022,
      poster: 'https://image.tmdb.org/t/p/w300/62HCnUTziyWcpDaBO2i1DX17ljH.jpg',
      genres: ['Action', 'Drama'],
      rating: 4.8,
      commentCount: 987,
      trending: true,
      latestComment: {
        text: 'Tom Cruise không bao giờ làm tôi thất vọng. Phim hay tuyệt!',
        user: 'ThaoLe',
        timeAgo: '5 phút trước',
      },
    },
    {
      id: 3,
      title: 'Everything Everywhere All at Once',
      year: 2022,
      poster: 'https://image.tmdb.org/t/p/w300/w3LxiVYdWWRvEVdn5RYq6jIqkb1.jpg',
      genres: ['Comedy', 'Drama', 'Sci-Fi'],
      rating: 4.7,
      commentCount: 756,
      trending: false,
      latestComment: {
        text: 'Phim này sâu sắc và vui nhộn cùng lúc. Michelle Yeoh xuất sắc!',
        user: 'DucTran',
        timeAgo: '12 phút trước',
      },
    },
    {
      id: 4,
      title: 'Avatar: The Way of Water',
      year: 2022,
      poster: 'https://image.tmdb.org/t/p/w300/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg',
      genres: ['Action', 'Adventure', 'Sci-Fi'],
      rating: 4.5,
      commentCount: 1247,
      trending: true,
      latestComment: {
        text: 'CGI tuyệt vời nhất từng thấy! James Cameron thật là thiên tài',
        user: 'MinhNguyen',
        timeAgo: '2 phút trước',
      },
    },
  ],

  featuredComments: [
    {
      id: 1,
      user: {
        name: 'NguyenVanA',
        avatar: 'https://randomuser.me/api/portraits/men/32.jpg',
        badge: 'Top Reviewer',
        verified: true,
      },
      movie: 'Avatar: The Way of Water',
      moviePoster: 'https://image.tmdb.org/t/p/w300/t6HIqrRAclMCA60NsSmeqe9RmNV.jpg',
      rating: 5,
      text: 'Phim hay nhất năm! Diễn xuất của Zoe Saldana quá tuyệt vời, CGI realistic đến không tin nổi. James Cameron đã tạo ra một thế giới hoàn toàn mới và sống động. Cảnh quay dưới nước thật sự ngoạn mục!',
      likes: 234,
      replies: 45,
      timeAgo: '1 giờ trước',
      isHearted: true,
    },
    {
      id: 2,
      user: {
        name: 'MovieCritic_VN',
        avatar: 'https://randomuser.me/api/portraits/women/45.jpg',
        badge: 'Film Expert',
        verified: true,
      },
      movie: 'Top Gun: Maverick',
      moviePoster: 'https://image.tmdb.org/t/p/w300/62HCnUTziyWcpDaBO2i1DX17ljH.jpg',
      rating: 5,
      text: 'Tom Cruise ở tuổi 60 vẫn bay lượn trên không như một phi công thực thụ! Những cảnh bay thực tế không CGI tạo ra cảm giác hồi hộp và chân thực đến không thể tin được. Đây là cách làm phim hành động đúng nghĩa!',
      likes: 1247,
      replies: 89,
      timeAgo: '3 giờ trước',
      isHearted: true,
    },
    {
      id: 3,
      user: {
        name: 'CinemaLover2024',
        avatar: 'https://randomuser.me/api/portraits/men/67.jpg',
        badge: 'Oscar Predictor',
        verified: true,
      },
      movie: 'Everything Everywhere All at Once',
      moviePoster: 'https://image.tmdb.org/t/p/w300/w3LxiVYdWWRvEVdn5RYq6jIqkb1.jpg',
      rating: 5,
      text: 'Phim này đã thay đổi cách tôi nhìn về điện ảnh! Multiverse concept được khai thác một cách sáng tạo và cảm động. Michelle Yeoh thật sự xuất sắc, xứng đáng với Oscar. Một tác phẩm nghệ thuật thực sự!',
      likes: 1892,
      replies: 156,
      timeAgo: '1 ngày trước',
      isHearted: true,
    },
    {
      id: 4,
      user: {
        name: 'VietnameseFilmFan',
        avatar: 'https://randomuser.me/api/portraits/women/23.jpg',
        badge: 'Hidden Gems',
        verified: true,
      },
      movie: 'The Batman',
      moviePoster: 'https://image.tmdb.org/t/p/w300/b0PlSFdDwbyK0cf5RxwDpaOJQvQ.jpg',
      rating: 4,
      text: 'Robert Pattinson đã chứng minh anh ấy xứng đáng khoác lên mình bộ đồ của Dark Knight. Phim tối tăm, nghiêm túc và có chiều sâu tâm lý. Gotham City chưa bao giờ đáng sợ và hấp dẫn đến thế!',
      likes: 967,
      replies: 78,
      timeAgo: '6 giờ trước',
      isHearted: true,
    },
    {
      id: 5,
      user: {
        name: 'AsianCinemaLover',
        avatar: 'https://randomuser.me/api/portraits/men/89.jpg',
        badge: 'International',
        verified: true,
      },
      movie: 'Parasite',
      moviePoster: 'https://image.tmdb.org/t/p/w300/7IiTTgloJzvGI1TAYymCfbfl3vT.jpg',
      rating: 5,
      text: 'Bong Joon-ho đã tạo ra một kiệt tác về bất bình đẳng xã hội. Mỗi khung hình đều được tính toán kỹ lưỡng, twist cuối phim khiến tôi không thể ngủ được! Xứng đáng là phim đầu tiên của châu Á thắng Oscar.',
      likes: 2847,
      replies: 203,
      timeAgo: '2 ngày trước',
      isHearted: true,
    },
  ],

  liveComments: [
    {
      id: 1,
      user: 'MinhNguyen',
      movie: 'Avatar 2',
      text: 'CGI quá đỉnh, thật sự ấn tượng!',
      timeAgo: '2 giây',
      type: 'comment',
    },
    {
      id: 2,
      user: 'ThaoLe',
      movie: 'Top Gun: Maverick',
      text: 'Tom Cruise không bao giờ làm tôi thất vọng',
      rating: 5,
      timeAgo: '5 giây',
      type: 'rating',
    },
    {
      id: 3,
      user: 'DucTran',
      movie: 'Titanic',
      text: 'Ending này không hợp lý chút nào...',
      timeAgo: '12 giây',
      type: 'debate',
    },
    {
      id: 4,
      user: 'LanAnh',
      movie: 'The Batman',
      text: 'Robert Pattinson thể hiện Batman rất hay!',
      timeAgo: '25 giây',
      type: 'comment',
    },
    {
      id: 5,
      user: 'HungPham',
      movie: 'Spider-Man: No Way Home',
      text: 'Tobey Maguire xuất hiện làm tôi khóc luôn',
      timeAgo: '43 giây',
      type: 'emotion',
    },
  ],

  stats: {
    todayComments: 1234,
    activeUsers: 456,
    newReviews: 89,
    growthPercent: 45,
  },

  leaderboard: [
    {
      rank: 1,
      user: 'CinePhile_VN',
      points: 2456,
      badge: '🥇',
      achievement: 'Top Reviewer',
    },
    {
      rank: 2,
      user: 'MovieLover88',
      points: 1890,
      badge: '🥈',
      achievement: 'Rising Star',
    },
    {
      rank: 3,
      user: 'FilmCritic_HN',
      points: 1445,
      badge: '🥉',
      achievement: 'Genre Expert',
    },
  ],

  trendingTags: [
    { tag: 'Marvel', count: 456, growth: 23 },
    { tag: 'Action', count: 321, growth: 15 },
    { tag: 'Romance', count: 234, growth: 8 },
    { tag: 'Comedy', count: 198, growth: -2 },
    { tag: 'Horror', count: 167, growth: 31 },
    { tag: 'Sci-Fi', count: 145, growth: 12 },
  ],

  genreTrending: [
    {
      genre: 'Action',
      percentage: 89,
      color: '#EF4444',
      icon: '💥',
      movies: 234,
      change: '+12%',
      trend: 'up',
    },
    {
      genre: 'Romance',
      percentage: 67,
      color: '#EC4899',
      icon: '💖',
      movies: 156,
      change: '+8%',
      trend: 'up',
    },
    {
      genre: 'Comedy',
      percentage: 54,
      color: '#F59E0B',
      icon: '😂',
      movies: 89,
      change: '+3%',
      trend: 'up',
    },
    {
      genre: 'Horror',
      percentage: 43,
      color: '#8B5CF6',
      icon: '👻',
      movies: 67,
      change: '+15%',
      trend: 'up',
    },
    {
      genre: 'Sci-Fi',
      percentage: 32,
      color: '#06B6D4',
      icon: '🚀',
      movies: 45,
      change: '+5%',
      trend: 'up',
    },
    {
      genre: 'Drama',
      percentage: 28,
      color: '#10B981',
      icon: '🎭',
      movies: 78,
      change: '-2%',
      trend: 'down',
    },
    {
      genre: 'Thriller',
      percentage: 38,
      color: '#F97316',
      icon: '⚡',
      movies: 52,
      change: '+9%',
      trend: 'up',
    },
    {
      genre: 'Fantasy',
      percentage: 25,
      color: '#A855F7',
      icon: '🧙‍♂️',
      movies: 34,
      change: '+7%',
      trend: 'up',
    },
    {
      genre: 'Animation',
      percentage: 41,
      color: '#14B8A6',
      icon: '🎨',
      movies: 29,
      change: '+11%',
      trend: 'up',
    },
  ],

  specialCategories: [
    {
      title: 'Tâm sự đêm khuya',
      icon: '🌙',
      count: 34,
      description: 'Những suy nghĩ sâu lắng về phim',
    },
    {
      title: 'Guilty Pleasure',
      icon: '😅',
      count: 67,
      description: 'Những bộ phim yêu thích bí mật',
    },
    {
      title: 'Phim gia đình',
      icon: '👨‍👩‍👧‍👦',
      count: 45,
      description: 'Phim phù hợp xem cùng gia đình',
    },
  ],
};

export default movieBuzzData;
